import Reflux from 'reflux'

let Actions = Reflux.createActions([
  'setCustomerUploadData',
  'setSupplierUploadData',
  'setSupplierRules',
  'setBankUploadData',
  'setCustomerAssignmentData',
  'setUnprocessedFlag',
  'setProcessedItems',
  'setUnProcessedItems',
  'setCashregisterOutputFiles',
  'uploadDataSet',
  'userBalanceSet',
  'updateStartEndDate',
])

export default Actions


// WEBPACK FOOTER //
// ./src/actions/actions.js